// @flow

import localforage from 'localforage';
import React from 'react';
import ReactDOM from 'react-dom';

import Launcher from './Launcher.jsx';

import {is_uuid, get_url_value} from './utils.js';
import {DOMAIN} from './consts.js';

import type {T_User} from './types.js';

import './css/vars.css';



// if (window.location.port === '' && window.location.href.indexOf('gdb.agrosat.cl') !== -1) {
//   window.location.replace('https://gdb.agrosat.cl:444/');
// }



localforage.config({
  name       : 'gdb3',
  version    : 1.0,
  description: 'gdb3 persistent storage'
});



const root = document.getElementById('root');



function guest(): void {
  if (root != null) {
    ReactDOM.render(
      <Launcher
        user={null}
        height={window.innerHeight}
        width={window.innerWidth}
      />,
      root
    );
  }
}



function setup(): void {
  localforage.getItem('full_user').then((full_user: ?T_User) => {
    const user: ?T_User = full_user,
          url           = window.location.href,
          session_index = url.indexOf('session_id');
    
    if (((! user) || url.indexOf('new_login') !== -1) && session_index === -1) {
      guest();
    }
    else {
      const session_id    = user != null ? user.session_id : get_url_value('session_id'),
            url_validator = `https://${DOMAIN}/valid-session/?session_id=${session_id}`;
      
      fetch(url_validator).then(resp => resp.json()).then((response: boolean | {error: string}) => {
        if (typeof response !== 'boolean') {
          guest();
        }
        else {
          const valid = (response: boolean);
          
          if (valid) {
            const welcome = (the_user) => {
              if (root != null) {
                ReactDOM.render(
                  <Launcher
                    user={the_user}
                    height={window.innerHeight}
                    width={window.innerWidth}
                  />,
                  root
                );
              }
            };
            
            if (user != null) {
              welcome(user);
            }
            else if (is_uuid(session_id)) {
              const url_auth = `https://${DOMAIN}/auth-user-by-session/?session_id=${session_id}`;
              
              fetch(url_auth).then(resp => resp.json()).then((response: T_User | string) => {
                if (typeof response === 'string') {
                  guest();
                }
                else {
                  const user = (response: T_User);
                  
                  welcome(user);
                }
              });
            }
            else {
              guest();
            }
          }
        }
      });
    }
  });
}



(() => localforage.ready().then(setup))();



// WEBPACK FOOTER //
// ./src/index.js